var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpPreviousArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "up_previous_arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "next_arrow",
    d: "M10.2299 0.706832C11.022 0.0047989 12.2364 0.0732144 12.9396 0.866437C13.644 1.65965 13.5732 2.87288 12.78 3.57731L7.91505 7.90219H13.4258C21.3665 7.90219 27.8262 14.3619 27.8262 22.3026C27.8262 23.3622 26.9657 24.2227 25.9061 24.2227C24.8465 24.2227 23.9861 23.3622 23.9861 22.3026C23.9861 16.4801 19.2483 11.7423 13.4258 11.7423H7.91505L12.78 16.0672C13.5732 16.7716 13.644 17.9848 12.9396 18.7781C12.5616 19.2041 12.0348 19.4225 11.5056 19.4225C11.0519 19.4225 10.5959 19.2629 10.2311 18.9377L1.59089 11.2575C1.1793 10.8927 0.945263 10.3706 0.945263 9.82222C0.945263 9.27379 1.17927 8.75178 1.5897 8.38697L10.2299 0.706832Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpPreviousArrow);
export default __webpack_public_path__ + "static/media/up_previous_arrow.fd4e85df8203c22a1f23bcf83ee4be35.svg";
export { ForwardRef as ReactComponent };